"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryRewardsList = void 0;
const TimeUtil_1 = require("../../utils/TimeUtil");
const DateTimeFormatter_1 = __importDefault(require("../../utils/DateTimeFormatter"));
class HistoryRewardsList extends Array {
    constructor() {
        super(...arguments);
        this.getDateStartSorted = () => {
            const rewardsList = new HistoryRewardsList();
            if (this.length > 0) {
                this.sort((x, y) => {
                    const dateCreatedX = !!x.date_created ? x.date_created : 0;
                    const dateCreatedY = !!y.date_created ? y.date_created : 0;
                    return dateCreatedX > dateCreatedY ? -1 : 1;
                }).forEach(x => {
                    let dateCreated = x.date_created;
                    if (x.date_created && !/^-?\d+$/.test(dateCreated)) {
                        dateCreated = (0, TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear)(x.date_created);
                    }
                    x.dateCreated = DateTimeFormatter_1.default.getFormattedDateFromTimeStamp('historyDateFormat', dateCreated);
                    rewardsList.push(x);
                });
            }
            return rewardsList;
        };
    }
}
exports.HistoryRewardsList = HistoryRewardsList;
//# sourceMappingURL=HistoryRewardsList.js.map